"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRE_BUILD_MARKSHEET = exports.HEARTBEAT_QBANK = exports.MARKSHEET_FEEDBACK = exports.FLAGGED_QUESTIONS_MARKSHEET = exports.FLAGGED_QUESTIONS = exports.LATEST_PAST_SESSION_ID = exports.LATEST_PAST_MARKSHEET_ID = exports.MARKSHEETS_WINDOW = exports.MARKSHEETS = exports.MARKSHEET = void 0;
const client_1 = require("@apollo/client");
const marksheet_1 = require("../../fragments/marksheet");
exports.MARKSHEET = (0, client_1.gql) `
  ${marksheet_1.MARKSHEET_FIELDS}
  query Marksheet($id: Int!) {
    restricted {
      marksheet(id: $id) {
        ...MarksheetFields
      }
    }
  }
`;
exports.MARKSHEETS = (0, client_1.gql) `
  query Marksheets($filter: MarksheetFilterInput!) {
    restricted {
      marksheets(filter: $filter) {
        results {
          id
          source
          endedAt
          topicNames
          correct
          incorrect
          totalQuestions
          isTestMarksheet
          solo
          completed
          passingMark
          duration
          updatedAt
          users {
            id
            displayName
          }
          marks {
            question {
              topic {
                typeId
                name
              }
            }
          }
        }
        total
        score
      }
    }
  }
`;
exports.MARKSHEETS_WINDOW = (0, client_1.gql) `
  query MarksheetsWindow($filter: MarksheetWindowFilterInput!) {
    restricted {
      marksheetsWindow(filter: $filter) {
        results {
          date
          result {
            id
            source
            endedAt
            topicNames
            correct
            incorrect
            totalQuestions
            typeId
            entitlement {
              id
              name
            }
            isTestMarksheet
            solo
            completed
            updatedAt
          }
        }
        total
        score
      }
    }
  }
`;
exports.LATEST_PAST_MARKSHEET_ID = (0, client_1.gql) `
  query LatestPastMarksheetId {
    restricted {
      latestPastMarksheetId
    }
  }
`;
exports.LATEST_PAST_SESSION_ID = (0, client_1.gql) `
  query LatestSessionId {
    restricted {
      latestSessionId
    }
  }
`;
exports.FLAGGED_QUESTIONS = (0, client_1.gql) `
  query FlaggedQuestions($filter: FlaggedQuestionInput!) {
    restricted {
      flaggedQuestions(filter: $filter) {
        total
        results {
          createdAt
          id
          userId
          markId
          questionId
          question {
            id
            question
            typeId
            conceptId
            concept {
              id
              name
              topic {
                id
                name
                typeId
              }
            }
          }
        }
      }
    }
  }
`;
exports.FLAGGED_QUESTIONS_MARKSHEET = (0, client_1.gql) `
  ${marksheet_1.MARKSHEET_FIELDS}
  query FlaggedQuestionsMarksheet {
    restricted {
      flaggedQuestionsMarksheet {
        ...MarksheetFields
      }
    }
  }
`;
/**
 * @deprecated Use MARKSHEETS query intead
 */
exports.MARKSHEET_FEEDBACK = (0, client_1.gql) `
  query MarksheetFeedback($id: Int!) {
    restricted {
      marksheetFeedback(id: $id) {
        marksheetId
        mockTestId
        correct
        incorrect
        total
        topics {
          topicId
          avgScore
          name
          score
        }
        timeTaken
        passingMark
      }
    }
  }
`;
exports.HEARTBEAT_QBANK = (0, client_1.gql) `
  query HeartbeatQbank($sessionId: String!) {
    restricted {
      heartbeatQbank(sessionId: $sessionId)
    }
  }
`;
exports.PRE_BUILD_MARKSHEET = (0, client_1.gql) `
  query PreBuildMarksheet(
    $topicIds: [Int!]
    $conceptIds: [Int!]
    $source: String!
    $search: String
    $marksheetId: Int
    $difficulty: [Int!]
    $entitlementId: Int
    $useAI: Boolean
  ) {
    restricted {
      preBuildMarksheet(
        topicIds: $topicIds
        conceptIds: $conceptIds
        source: $source
        search: $search
        marksheetId: $marksheetId
        difficulty: $difficulty
        entitlementId: $entitlementId
        useAI: $useAI
      ) {
        unseen
        seenCorrect
        seenIncorrect
        buildRef
      }
    }
  }
`;
